/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetExamsByExaminer: {
        $xmlns: 'http://dobs.pa.gov/nd/exam/bpm/1.0'
      }
    },
    blueprintArrays: ['GetExamsByExaminerResponse.ND_Exam'],
    blueprint: {
      exam: [
        '$..ND_Exam',
        {
          examId: '$.ExamID',
          entityId: '$.EntityID',
          entityName: '$.EntityName',
          examDate: '$.ExamDate',
          statusId: '$.StatusID',
          status: '$.Status',
          primaryFirstName: '$.PrimaryFirstName',
          primaryLastName: '$.PrimaryLastName',
          region: '$.Region',
          licenseNumber: '$.LicenseNumber',
          licenseType: '$.LicenseType',
          licenseTypeId: '$.LicenseTypeID',
          licenseId: '$.LicenseID',
          examiners: '$.Examiners',
          primaryExaminerUserId: '$.PrimaryExaminerUserId',
          examCoverageStartDate: '$.ExamCoverageStartDate',
          examCoverageEndDate: '$.ExamCoverageEndDate',
          examStartDate: '$.ExamStartDate',
          examEndDate: '$.ExamEndDate'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      var dateKeys = ['examDate', 'examCoverageStartDate', 'examCoverageEndDate', 'examStartDate', 'examEndDate'];

      _.each(response.exam, function(exam) {
        if (!exam) {
          return;
        }

        // format dates
        _.each(dateKeys, function(dateKey) {
          var dateVal = exam[dateKey];
          if (dateVal) {
            exam[dateKey] = moment(dateVal, moment.ISO_8601);
          }
        });

        // concat examiners
        var primary = exam.primaryExaminerUserId;
        var others = exam.examiners;

        if (primary && others) {
          exam.examiners = primary + ', ' + others;
        } else if (primary) {
          exam.examiners = primary;
        } else {
          exam.examiners = others;
        }
      });

      defer.resolve(response.exam);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
